import Notification from "@/components/notifications/Notification"
import React from "react"

interface NotificationType {
  data: {
    type: string
    text: string
  }
  created_at: string
}

type NotificationCardProps = {
  notification: NotificationType
}

export default function NotificationCard(props: NotificationCardProps) {
  const { notification } = props

  switch (notification.data.type) {
    default:
      return <Notification notification={notification} />
  }
}
